import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const TargetActiveSvg = ({ size = 24 }) => (
  <SvgWrapper size={size}>
    <path
      d="M18.6958 5.29659C16.979 3.56546 14.5987 2.49335 11.9681 2.49335C6.73533 2.49335 2.49335 6.73533 2.49335 11.9681C2.49335 17.2008 6.73533 21.4428 11.9681 21.4428V21.4428C17.2008 21.4428 21.4428 17.2008 21.4428 11.9681C21.4428 10.119 20.9131 8.39359 19.9972 6.93538"
      stroke="url(#paint0_linear-target)"
      strokeWidth="2.99202"
    />
    <path
      d="M15.4852 8.61111C14.5998 7.68377 13.3514 7.10605 11.9681 7.10605C9.28286 7.10605 7.10605 9.28286 7.10605 11.9681C7.10605 14.6533 9.28286 16.8301 11.9681 16.8301V16.8301C14.6533 16.8301 16.8301 14.6533 16.8301 11.9681C16.8301 11.4744 16.7565 10.9979 16.6197 10.5489"
      stroke="url(#paint1_linear-target)"
      strokeWidth="1.99468"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9681 13.6823C12.9148 13.6823 13.6823 12.9148 13.6823 11.9681C13.6823 11.0214 12.9148 10.2539 11.9681 10.2539C11.0214 10.2539 10.2539 11.0214 10.2539 11.9681C10.2539 12.9148 11.0214 13.6823 11.9681 13.6823Z"
      fill="#E06065"
    />
    <path
      d="M11.4694 12.5376L20.3298 3.6773"
      stroke="url(#paint2_linear-target)"
      strokeWidth="1.49601"
    />
    <path
      d="M20.2484 1.30121V3.98935H22.7902"
      stroke="#EE8E93"
      strokeWidth="1.99468"
    />
    <defs>
      <linearGradient
        id="paint0_linear-target"
        x1="2.49335"
        y1="2.49335"
        x2="2.49335"
        y2="21.4428"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#65C4FF" />
        <stop offset="1" stopColor="#46AAE9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear-target"
        x1="1.28628"
        y1="0.283201"
        x2="1.28628"
        y2="21.6468"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A1F7CD" />
        <stop offset="0.999842" stopColor="#32AC80" />
      </linearGradient>
      <linearGradient
        id="paint2_linear-target"
        x1="16.0648"
        y1="-2.51404"
        x2="6.17163"
        y2="6.17685"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F2999E" />
        <stop offset="1" stopColor="#E06065" />
      </linearGradient>
    </defs>
  </SvgWrapper>
)
